<script>
import Vue from 'vue'
import getAddress from '@/modules/mixins/getAddress'
import ModalSelectLocation from '@/components/organism/location/ModalSelectLocation'
import { mapGetters } from 'vuex'
import isEmpty from 'lodash.isempty'

export default {
    name: 'InitLocation',
    components: {
        ModalAddLocation: () => import('@/components/organism/location/ModalAddLocation'),
        ModalEditLocation: () => import('@/components/organism/location/ModalEditLocation'),
        ModalEnterLocation: () => import('@/components/organism/location/ModalEnterLocation'),
        ModalSelectLocation,
    },
    mixins: [getAddress],
    computed: {
        ...mapGetters({
            orderAddress: 'order/address',
            activeCanteen: 'active/canteen',
        }),
        isLoggedIn() {
            return this.$user?.isLoggedIn
        },
    },
    beforeCreate() {
        Vue.prototype.$location = {
            add: {
                open: (address, callback, updateAddress) =>
                    this.$refs.ModalAddLocation.open(address, callback, updateAddress),
                close: () => this.$refs.ModalAddLocation.close(),
            },
            edit: {
                open: (address) => this.$refs.ModalEditLocation.open(address),
                close: () => this.$refs.ModalEditLocation.close(),
            },
            select: {
                open: (callback, error) => this.$refs.ModalSelectLocation.open(callback, error),
                close: () => this.$refs.ModalSelectLocation.close(),
                showSorting: () => this.$refs.ModalSelectLocation.showOnlySortState(),
                set: (address, closeModal, callback) =>
                    this.$refs.ModalSelectLocation.setAddress(address, closeModal, callback),
            },
            enter: {
                open: (callback, error) => this.$refs.ModalEnterLocation.open(callback, error),
                close: () => this.$refs.ModalEnterLocation.close(),
            },
            // location=47.4998389|19.0859369
            // location=51.5236448|-0.0979616
            check: async (route) => {
                // eslint-disable-next-line no-console
                if (!route) console.error('Route missing at InitLocation > check()')
                const queryLocation = route?.query?.location?.split('|')?.reduce((p, c, index) => {
                    if (index > 1) return p
                    if (index) p.longitude = Number(c)
                    else p.latitude = Number(c)
                    return p
                }, {})
                const queryAddress = route?.query?.address ? parseInt(route.query.address) : null
                let resultAddress
                if (Vue.prototype.$user.isLoggedIn) {
                    await this.$addresses.initAddresses()
                    if (this.activeCanteen?.id) {
                        if (this.activeCanteen.address !== this.$cart.address) {
                            this.$cart.address = this.activeCanteen.address.isResidential
                                ? this.activeCanteen.address.address
                                : this.$addresses.findItem(
                                      this.getId(this.activeCanteen.address.address)
                                  )
                        }
                        return
                    }
                    // user logged in
                    if (queryAddress) {
                        // has address id in query
                        resultAddress = this.$addresses.findItem(queryAddress)?.model
                        if (resultAddress) {
                            // found address amongst user addresses, set location
                            this.$refs.ModalSelectLocation.setAddress(resultAddress, false)
                            return
                        } else {
                            // remove address id from query
                            this.setQuery({ address: undefined })
                        }
                    }
                    if (queryLocation) {
                        // has location in query
                        if (this.$addresses.isValidLocation(queryLocation)) {
                            // valid location coodinates
                            // try to find location amongst saved user addresses
                            await this.$addresses.initAddresses()
                            resultAddress = this.$addresses.findAddress(queryLocation)?.model
                            if (resultAddress) {
                                // found address amongst user addresses, set location
                                this.$refs.ModalSelectLocation.setAddress(resultAddress, false)
                                return
                            } else {
                                // no address was found
                                try {
                                    if (
                                        this.$addresses.isSameLocation(
                                            queryLocation,
                                            this.orderAddress
                                        )
                                    ) {
                                        // check if the address is store in cookies
                                        this.$refs.ModalSelectLocation.setAddress(
                                            this.orderAddress,
                                            false
                                        )
                                        return
                                    } else {
                                        // get address from google
                                        resultAddress = await this.getConvertedAddress(
                                            queryLocation.latitude,
                                            queryLocation.longitude
                                        )
                                        // set location as temporary address
                                        this.$refs.ModalSelectLocation.setAddress(
                                            resultAddress,
                                            false
                                        )
                                        return
                                    }
                                } catch {
                                    // eslint-disable-next-line no-console
                                    console.error('Error during google api call.')
                                    await this.$store.dispatch('order/resetAddress')
                                    this.setQuery({ location: undefined })
                                    this.$refs.ModalSelectLocation.open(
                                        undefined,
                                        'details.url_invalid_location'
                                    )
                                    return
                                }
                            }
                        } else {
                            // not valid location coodinates
                            // remove location from query
                            await this.$store.dispatch('order/resetAddress')
                            this.setQuery({ location: undefined })
                            this.$refs.ModalSelectLocation.open(
                                undefined,
                                'details.url_invalid_location'
                            )
                            return
                        }
                    }
                    if (!isEmpty(this.orderAddress)) {
                        // location stored in local storage
                        if (this.orderAddress.id) {
                            // saved address is in local storage
                            resultAddress = this.$addresses.findItem(this.orderAddress.id)?.model
                            if (resultAddress) {
                                // address is still amongst saved addresses
                                this.$refs.ModalSelectLocation.setAddress(resultAddress, false)
                                return
                            } else {
                                // address already deleted
                                await this.$store.dispatch('order/resetAddress')
                            }
                        } else {
                            // temporary address is in local storage
                            // check if temporary address is stored amongst saved addresses
                            resultAddress = this.$addresses.findAddress(this.orderAddress)?.model
                            if (resultAddress) {
                                // address is amongst saved addresse
                                this.$refs.ModalSelectLocation.setAddress(resultAddress, false)
                                return
                            } else {
                                try {
                                    if (this.$addresses.isValidLocation(this.orderAddress)) {
                                        // check if the address is valid
                                        this.$refs.ModalSelectLocation.setAddress(
                                            this.orderAddress,
                                            false
                                        )
                                        return
                                    } else if (
                                        this.$addresses.isValidLocation({
                                            latitude: this.orderAddress.original_latitude,
                                            longitude: this.orderAddress.original_longitude,
                                        })
                                    ) {
                                        // check if original coordinates are valid => get addres from google
                                        resultAddress = await this.getConvertedAddress(
                                            this.orderAddress.original_latitude,
                                            this.orderAddress.original_longitude
                                        )
                                        this.$refs.ModalSelectLocation.setAddress(
                                            resultAddress,
                                            false
                                        )
                                        return
                                    } else {
                                        // reset address
                                        await this.$store.dispatch('order/resetAddress')
                                    }
                                } catch {
                                    // eslint-disable-next-line no-console
                                    console.error('Error during google api call.')
                                    await this.$store.dispatch('order/resetAddress')
                                }
                            }
                        }
                    }
                    // no stored location in local storage OR there is an address in local storage but: addres is deleted OR cannot fetch the location from google
                    if (this.$addresses.total === 1) {
                        // has exactly one saved address
                        this.$refs.ModalSelectLocation.setAddress(
                            this.$addresses.items[0]?.model,
                            false
                        )
                        return
                    } else {
                        // multiple saved address
                        this.$refs.ModalSelectLocation.open()
                        return
                    }
                } else {
                    // user not logged in
                    if (queryAddress) {
                        // remove address id from query
                        this.setQuery({ address: undefined })
                    }
                    if (queryLocation) {
                        // has location in query
                        if (this.$addresses.isValidLocation(queryLocation)) {
                            if (!this.$addresses.isSameLocation(queryLocation, this.orderAddress)) {
                                // valid location coodinates and the address is not stored in cookies
                                // get address from google
                                resultAddress = await this.getConvertedAddress(
                                    queryLocation.latitude,
                                    queryLocation.longitude
                                )
                                // set location as temporary address
                                this.$refs.ModalSelectLocation.setAddress(resultAddress, false)
                                return
                            }
                        } else {
                            // not valid location coodinates
                            // remove location from query
                            await this.$store.dispatch('order/resetAddress')
                            this.setQuery({ location: undefined })
                            this.$refs.ModalEnterLocation.open(
                                undefined,
                                'details.url_invalid_location'
                            )
                            return
                        }
                    }
                    if (!isEmpty(this.orderAddress)) {
                        if (
                            !this.$addresses.isValidLocation(this.orderAddress) ||
                            !!this.orderAddress.id
                        ) {
                            // has address in cookies, but the coordinates are invalid or it has an id
                            // (which means this is a user address => under normal circumstances this is not possible )
                            this.$store.dispatch('order/resetAddress')
                        } else if (!queryLocation) {
                            // has valid address in cookies, but there are no coordinates in url
                            this.$location.select.set(this.orderAddress, false)
                        }
                    }
                }
                return
            },
        }
    },
    created() {
        if (!this.$store.getters['site/listView']) this.$location.check(this.$route)
    },
}
</script>

<template lang="pug">
div
    modal-edit-location(ref="ModalEditLocation")
    modal-select-location(ref="ModalSelectLocation")
    modal-add-location(ref="ModalAddLocation")
    modal-enter-location(ref="ModalEnterLocation")
    
</template>

<style lang="scss">
.enter-location,
.select-location,
.edit-location,
.add-location {
    .modal-header {
        > div,
        h1 {
            width: 100%;
        }
    }
}
.edit-location,
.add-location {
    .modal-dialog .modal-content {
        height: var(--modal-height);
        overflow: hidden;
        .modal-header {
            .step-indicator {
                position: absolute;
                display: flex;
                justify-content: center;
                top: 20px;
                left: 50%;
                transform: translateX(-50%);
                span {
                    height: 3px;
                    width: 80px;
                    background-color: var(--dark-cc);
                    margin: 5px;
                    border-radius: 99999px;
                    &.fill-step {
                        background-color: var(--primary-1);
                    }
                }
            }
            // .close-modal {
            //     top: 36px;
            // }
            // .btn-white-primary,
            // .btn-white-danger {
            //     top: 29px;
            // }
        }
        .modal-body {
            display: flex;
            flex-direction: column;
            overflow: hidden;
            &:has(> .slide-modal-content-l-absolute-enter-active),
            &:has(> .slide-modal-content-l-absolute-leave-active) {
                background: none;
            }
        }
        .modal-footer {
            padding: 0;
        }
        .slide-modal-content-l-absolute-leave-active {
            width: calc(100% - 32px);
        }
        .slide-modal-content-l-absolute-enter-active {
            transition-delay: 0s !important;
        }
        h1.slide-modal-content-l-enter-active {
            transition-delay: 0s !important;
        }
    }
}
.select-location {
    .modal-dialog .modal-content {
        height: var(--modal-height);
    }
    .modal-footer {
        position: relative;
        height: 72px;
    }
}
</style>
